import script from "./graphDonutChart.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./graphDonutChart.component.vue?vue&type=script&lang=ts&setup=true"

import "./graphDonutChart.component.vue?vue&type=style&index=0&id=4f986afe&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f986afe"]])

export default __exports__